var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"term-wrapper"},[_vm._t("operator"),_vm._v(" "),_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"remove-all-wrapper"},[_vm._t("remove-all")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }